<section class="animation-effects" [ngClass]="{'animate' : showAnimation}">
  <div class="contact-content">
    <p>If you have any questions, please feel free to contact us at:</p>
    <p>
      <strong>888-209-7905</strong>
    </p>
  </div>
</section>
